import { Box, Flex } from '@/ui';
import { ACCENT, BAR } from './constants';

export const PosterThumbnail = () => (
  <Flex direction="column" gap="5px" h="full" w="full">
    <Box bg={ACCENT} borderRadius="3px" flex={1} opacity={0.4} />
    <Box bg={BAR} borderRadius="2px" h="6px" w="70%" />
  </Flex>
);
